/**
 * Shared Routes Constants and Utilities
 */

import { Bike, Car, Truck } from "lucide-react";

export const vehicleOptions = [
  { id: "bike", name: "Bike/Scooter", icon: Bike, maxWeight: 5 },
  { id: "car", name: "Car/Sedan", icon: Car, maxWeight: 20 },
  { id: "van", name: "Van/Mini Truck", icon: Truck, maxWeight: 500 },
  { id: "truck", name: "Truck", icon: Truck, maxWeight: 2000 },
];

export const initialRouteForm = {
  origin: "",
  destination: "",
  via_stops: "",
  vehicle_type: "van",
  total_capacity: "",
  price_per_kg: "",
  departure_date: null,
  departure_time: "",
};

export const getVehicleIcon = (type) => {
  const vehicle = vehicleOptions.find((v) => v.id === type);
  return vehicle?.icon || Truck;
};
